export const KitReducer = (state, action) => {
  switch (action.type) {
    case 'SET_KIT_PRODUCTS':
      return {
        ...state,
        kitProducts: action.payload,
      };
    case 'UPDATE_KIT_PRODUCT':
      return {
        ...state,
        kitProducts: state.kitProducts.map((product, index) => {
          if (index === action.payload.index) {
            return action.payload.updatedProduct;
          }
          return product;
        }),
      };
    default:
      return state;
  }
};
